import { ApiService } from './api/api'

export default class FileService {
	private apiService

	constructor() {
		this.apiService = new ApiService()
	}

	/**
	 * Upload a file
	 * @returns Promise
	 */
	upload(value): Promise<any> {
		const formData = new FormData()
		formData.append('file', value)
		console.log(formData)
		return this.apiService.post(`/files/upload`, formData)
	}
}
